import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function posto(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@posto/FIND_POSTO':
      case '@posto/UPDATE_POSTO':
      case '@posto/DELETE_POSTO':
      case '@posto/STORE_POSTO':
      case '@posto/POSTOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@posto/SUCCESS_REMOVE':
      case '@posto/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@posto/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.postos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@posto/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.posto;
        break;
      }

      case '@posto/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
